<nav [attr.aria-label]="labels.nav" *ngIf="visible">
  <ul class="pagination">
    <li [class.hide_paginationItem]="pager.currentPage == 1">
      <a class="page-numbers" role="button" tabindex="0"
         [attr.aria-label]="labels.first"
         (click)="go(1)"
         (keydown.enter)="go(1)"
         (keydown.space)="go(1, $event)"
      ><span aria-hidden="true"><i class="fa fa-angle-double-left"></i></span></a>
    </li>
    <li [class.hide_paginationItem]="pager.currentPage == 1">
      <a class="next page-numbers" role="button" tabindex="0"
         [attr.aria-label]="labels.prev"
         (click)="go(pager.currentPage - 1)"
         (keydown.enter)="go(pager.currentPage - 1)"
         (keydown.space)="go(pager.currentPage - 1, $event)"
      ><span aria-hidden="true"><i class="fa fa-angle-left"></i></span></a>
    </li>

    <li *ngFor="let page of pager.pages">
      <a class="page-numbers" role="button" tabindex="0"
         [class.current]="pager.currentPage == page"
         [attr.aria-current]="pager.currentPage == page ? 'page' : null"
         (click)="go(page)"
         (keydown.enter)="go(page)"
         (keydown.space)="go(page, $event)"
      >{{page}}</a>
    </li>

    <li [class.hide_paginationItem]="pager.currentPage == pager.totalPages">
      <a class="next page-numbers" role="button" tabindex="0"
         [attr.aria-label]="labels.next"
         (click)="go(pager.currentPage + 1)"
         (keydown.enter)="go(pager.currentPage + 1)"
         (keydown.space)="go(pager.currentPage + 1, $event)"
      ><span aria-hidden="true"><i class="fa fa-angle-right"></i></span></a>
    </li>
    <li [class.hide_paginationItem]="pager.currentPage == pager.totalPages">
      <a class="page-numbers" role="button" tabindex="0"
         [attr.aria-label]="labels.last"
         (click)="go(pager.totalPages)"
         (keydown.enter)="go(pager.totalPages)"
         (keydown.space)="go(pager.totalPages, $event)"
      ><span aria-hidden="true"><i class="fa fa-angle-double-right"></i></span></a>
    </li>
  </ul>
</nav>
